import React, { type FC } from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';

import { ContainerSkeleton } from './ContainerSkeleton.tsx';
import { SPACE_NAVIGATION_METRIC } from './perf.config.ts';
import type { SpaceNavigationProps } from './SpaceNavigation.tsx';

const separatorStyles = css({
	marginBlock: token('space.0'),
	marginInline: token('space.negative.150'),
	border: token('space.0'),
	borderBottom: `${token('border.width')} solid ${token('color.border')}`,
});

const separatorStylesFallback = css({
	marginBlock: token('space.0'),
	marginInline: token('space.negative.150'),
	border: '0',
	borderBottom: `${token('border.width')} solid ${token('color.border')}`,
});

export const SpaceNavigationLoader: LoadableType<SpaceNavigationProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceNavigation" */ './SpaceNavigation.tsx'))
			.SpaceNavigation,
	loading: () => <ContainerSkeleton loader />,
});

export const SpaceNavigation: FC<SpaceNavigationProps> = (props) => {
	const separatorHr = fg('confluence_frontend_tokenize_border') ? (
		<hr role="presentation" css={separatorStyles} id="space-header-top-divider" />
	) : (
		<hr role="presentation" css={separatorStylesFallback} id="space-header-top-divider" />
	);

	return (
		<>
			{separatorHr}
			<PageSegmentLoadStart metric={SPACE_NAVIGATION_METRIC} />
			<SpaceNavigationLoader {...props} />
		</>
	);
};

export const SpaceNavigationLoadingSkeleton: FC = () => <ContainerSkeleton loader />;
